import React from "react";

const FileFailed = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.75 17H14.25C14.6642 17 15 16.6642 15 16.25V5.75L11.625 2H3.75C3.33579 2 3 2.33579 3 2.75V16.25C3 16.6642 3.33579 17 3.75 17Z"
      stroke="#C55353"
      strokeWidth="1.24138"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 8.75L11.25 13.25"
      stroke="#C55353"
      strokeWidth="1.24138"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 8.75L6.75 13.25"
      stroke="#C55353"
      strokeWidth="1.24138"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.25 2V5.75H15" stroke="#C55353" strokeWidth="1.24138" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default React.memo(FileFailed);
